'use strict';

export function tableWrapperInit() {
  const content = document.querySelector('.content');
  if (!content) return;

  const tables = content.querySelectorAll('table');

  tables.forEach(table => {
    // Sprawdź, czy tabela nie jest już opakowana
    if (!table.parentElement.classList.contains('table-wrapper')) {
      // Utwórz kontener
      const wrapper = document.createElement('div');
      wrapper.classList.add('table-wrapper');

      // Przenieś tabelę do kontenera
      table.parentNode.insertBefore(wrapper, table);
      wrapper.appendChild(table);

      // Dodaj styl overflow-x: auto
      wrapper.style.overflowX = 'auto';
    }
  });
}
